import {
  IRIRBufferingState,
  IRIBufferingActionTypes,
  GET_IRI_BUFFERING_LIST,
  GET_IRI_BUFFERING_LIST_FULFILLED,
  GET_IRI_BUFFERING_PENDING,
  GET_IRI_BUFFERING_FULFILLED,
  SELECT_IRI_BUFFERING,
  SET_IRI_BUFFERING_LOADING,
} from './iriBuffering.types';

export const initialState: IRIRBufferingState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function iriBufferingReducer(
  state = initialState,
  action: IRIBufferingActionTypes,
): IRIRBufferingState {
  switch (action.type) {
    case GET_IRI_BUFFERING_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_IRI_BUFFERING_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

    case GET_IRI_BUFFERING_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_IRI_BUFFERING_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_IRI_BUFFERING:
      return {
        ...state,
        selected: action.payload || [],
      };

    case SET_IRI_BUFFERING_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
